import { useState } from 'react';
import { useAuth } from '../../auth/AuthProvider';
import { shopApi } from '../../api/shop';
import { useShop } from '../../context/ShopContext';
import { config } from '../../config';
import { slugify } from '../../utils/format';

export default function CreateShopPage() {
  const { getToken } = useAuth();
  const { reloadShops, setSelectedShopId } = useShop();
  const [form, setForm] = useState({ store_name: '', store_slug: '' });
  const [slugTouched, setSlugTouched] = useState(false);
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const handleStoreNameChange = (storeName) => {
    setForm((prev) => ({
      ...prev,
      store_name: storeName,
      store_slug: slugTouched ? prev.store_slug : slugify(storeName),
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError(null);
    setSubmitting(true);

    try {
      const token = await getToken();
      const created = await shopApi.createMyShop(token, {
        name: form.store_name.trim(),
        slug: form.store_slug.trim(),
      });
      await reloadShops();
      setSelectedShopId(created.shop.id);
    } catch (err) {
      setError(err.message || 'Could not create your store. Please try again.');
      setSubmitting(false);
    }
  };

  return (
    <div className="create-shop-page">
      <div className="create-shop-panel">
        <div className="create-shop-header">
          <h1>Set up your store</h1>
          <p>Choose a name and address for your storefront.</p>
        </div>

        {error && <div className="signup-error">{error}</div>}

        <form className="create-shop-form" onSubmit={handleSubmit}>
          <div className="form-field">
            <label htmlFor="create-store-name">Store name</label>
            <input
              id="create-store-name"
              value={form.store_name}
              onChange={(event) => handleStoreNameChange(event.target.value)}
              required
              autoFocus
            />
          </div>

          <div className="form-field">
            <label htmlFor="create-store-slug">Store address</label>
            <div className="signup-url-field">
              <input
                id="create-store-slug"
                value={form.store_slug}
                onChange={(event) => {
                  setSlugTouched(true);
                  setForm((prev) => ({ ...prev, store_slug: event.target.value }));
                }}
                required
                pattern="[a-z0-9]+(?:-[a-z0-9]+)*"
                title="Lowercase letters, numbers, and hyphens only"
              />
              <span className="signup-url-suffix">.{config.storefrontDomainSuffix}</span>
            </div>
          </div>

          <button type="submit" className="btn btn-primary signup-submit" disabled={submitting}>
            {submitting ? 'Creating store…' : 'Create store'}
          </button>
        </form>
      </div>
    </div>
  );
}
